import { InputLabel } from "@mui/material";
import PropTypes from "prop-types";
import appcolors from "../../constants/Colors";

const Label = ({ labelText, required, optional, labelProps, htmlFor, errorRef }) => {
  return (
    <InputLabel
      sx={{
        marginBottom: "5px",
        fontSize: "0.875rem",
        color: appcolors.charcolGrey,
        ...labelProps,
      }}
      htmlFor={htmlFor}
      ref={errorRef}
    >
      {labelText}
      {required && <span style={{ color: appcolors.primary,marginLeft: "3px" }}>*</span>}
      {optional && <span>{" "}(optional)</span>}
    </InputLabel>
  );
};

Label.propTypes = {
  labelText: PropTypes.string.isRequired,
  required: PropTypes.bool,
  labelProps: PropTypes.object,
  htmlFor: PropTypes.string,
  errorRef: PropTypes.object,
};

Label.defaultProps = {
  required: false,
  labelProps: {},
  htmlFor: "",
  errorRef: null,
};

export default Label;
